<page-title text="Invite And Earn Competition | BitOasis" i18n-text="@@pageTitle.inviteAndEarnCompetition">Invite and Win Competition</page-title>

<site-header logo="assets/images/logo-primary.svg" class="light"></site-header>

<div class="container section">
    <header class="header">
        <div class="row">
            <div class="col-lg-7">
                <div class="header-img">
                    <img src="assets/images/contests/invite-and-win-hero-ramadan.png" alt="Invite And Win">
                </div>
            </div><!-- .img -->
            <div class="col-lg-5">
                <div class="header-content">
                    <h2 class="text-heading" i18n="@@front.inviteAndEarnCompetition.header.heading">INVITE &amp; WIN</h2>
                    <h1 class="text-title" i18n="@@front.inviteAndEarnCompetition.header.title">This Ramadan, let's give from the heart</h1>
                    <h3 class=" m-0" i18n="@@front.inviteAndEarnCompetition.header.title2">Pass on rewards and claim your own when your family and friends sign up with us</h3>

                    <div class="p-3"></div>

                    <section class="countdown">
                        <div class="wrapper">
                            <div class="timer">
                                <div class="time">
                                    <div class="label" i18n="@@front.inviteAndEarnCompetition.timer.days">DAYS</div>
                                    <div class="content">{{timer?.days | number:'2.0'}}</div>
                                </div>
                                <div class="separator">
                                    <div class="label">&nbsp;</div>
                                    <div class="content">:</div>
                                </div>
                                <div class="time">
                                    <div class="label" i18n="@@front.inviteAndEarnCompetition.timer.hours">HOURS</div>
                                    <div class="content">{{timer?.hours | number:'2.0'}}</div>
                                </div>
                                <div class="separator">
                                    <div class="label">&nbsp;</div>
                                    <div class="content">:</div>
                                </div>
                                <div class="time">
                                    <div class="label" i18n="@@front.inviteAndEarnCompetition.timer.minutes">MINUTES</div>
                                    <div class="content">{{timer?.minutes | number:'2.0'}}</div>
                                </div>
                            </div><!-- .timer -->
                        </div>
                    </section>

                    <div class="p-3"></div>

                    <p i18n="@@front.inviteAndEarnCompetition.header.content">Introduce crypto to loved ones and win from $5,000 in prizes on top of referral rewards</p>

                    <a routerLink="/affiliate-program" class="btn btn-lg btn-primary action" i18n="@@front.inviteAndEarnCompetition.header.actionButton">Start Inviting</a>
                </div><!-- .content -->
            </div>
        </div><!-- .row -->
    </header>
</div><!-- .container -->

<section class="how-participate section section-xs container">
    <div class="row">
        <div class="col-lg-auto">
            <div class="content">
                <h2 class="text-heading" i18n="@@front.inviteAndEarnCompetition.howToParticipate.heading">HOW TO PARTICIPATE</h2>
                <h3 class="text-title mb-4" i18n="@@front.inviteAndEarnCompetition.howToParticipate.title">Invite and you're in!</h3>
                <p i18n="@@front.inviteAndEarnCompetition.howToParticipate.description">Start inviting and we'll take care of the rest</p>
            </div>
        </div><!-- .content -->
        <div class="col-lg">
            <div class="visual">
                <div class="boxes">
                    <div class="d-flex justify-content-end">
                        <div class="visual-box down">
                            <div class="number">01</div>
                            <p class="text-lg text-bold" i18n="@@front.inviteAndEarnCompetition.howToParticipate.step1.title">Pass it on</p>
                            <p i18n="@@front.inviteAndEarnCompetition.howToParticipate.step1.description">Share your invite link and get them started on the region's most reliable crypto platform</p>
                        </div>
                        <div class="p-3"></div>
                        <div class="visual-box">
                            <div class="number">02</div>
                            <p class="text-lg text-bold" i18n="@@front.inviteAndEarnCompetition.howToParticipate.step2.title">Earn together</p>
                            <p i18n="@@front.inviteAndEarnCompetition.howToParticipate.step2.description">You'll both get rewards when your friends trade cryptocurrency with us</p>
                        </div>
                    </div>
                </div>
            </div>
        </div><!-- .visual -->
    </div>
</section>

<section class="container section section-xs prizes">
    <div class="wrapper">
        <div class="normal-box primary-box">
            <h2 class="text-heading mb-3" i18n="@@front.inviteAndEarnCompetition.prizes.grandPrize.heading">GRAND PRIZES</h2>
            <h3 class="text-title mt-0 mb-2" i18n="@@front.inviteAndEarnCompetition.prizes.grandPrize.title">Top 3 inviters share $5000</h3>
            <p i18n="@@front.inviteAndEarnCompetition.prizes.grandPrize.description">Invite the most to win from the $5000 prize pool*</p>
            <p class="content text-xs mt-3" i18n="@@front.inviteAndEarnCompetition.prizes.content">*To qualify for prizes, your friends must verify their account and buy the equivalent of AED 300 in cryptocurrency.</p>
        </div>
        <!-- <div class="normal-box secondary-box">
            <h2 class="text-heading" i18n="@@front.inviteAndEarnCompetition.prizes.prize.heading">PRIZES</h2>
            <h3 class="text-title" i18n="@@front.inviteAndEarnCompetition.prizes.prize.title">Everyone else splits $9000</h3>
            <p i18n="@@front.inviteAndEarnCompetition.prizes.prize.description">Everyone outside of the top 5 will split $9000. Invite your friends to win a <strong>guaranteed</strong> prize!*</p>
        </div> -->
    </div>
</section>

<section class="section section-sm container">
    <div class="top-chart">
        <div class="content contest-blog reward-table">
            <div class="chart-header">
                <h3 class="text-title" i18n="@@front.inviteAndEarnCompetition.rewards.title">Leaderboard</h3>
                <div class="date" i18n="@@front.inviteAndEarnCompetition.rewards.lastUpdated">Last updated: {{data?.createdAt | date:'medium'}}</div>
            </div>
            <table class="titles">
                <tr>
                    <td i18n="@@front.inviteAndEarnCompetition.rewards.rank" style="width: 25%;">Rank</td>
                    <td i18n="@@front.inviteAndEarnCompetition.rewards.name">Name</td>
                    <td i18n="@@front.inviteAndEarnCompetition.rewards.invitees">Invitees</td>
                </tr>
            </table>
            <loading *ngIf="loading" class="full" i18n="@@front.inviteAndEarnCompetition.rewards.loading">Loading top chart</loading>
            <error *ngIf="error" class="full" i18n="@@front.inviteAndEarnCompetition.rewards.error">Error loading top chart</error>
            <div *ngIf="!loading && !error" class="data" [innerHTML]="data?.content"></div>
        </div>
    </div>

    <div class="p-4"></div>
    <p class="text-center text-lg" i18n="@@front.inviteAndEarnCompetition.terms">Find the Terms & Conditions <a href="assets/images/contests/invite-and-earn-competition-terms-of-service/invite-and-earn-competition-ramadan-terms-of-service-{{isAr ? 'ar' : 'en'}}.pdf" target="_blank">here</a></p>
</section>

<site-footer></site-footer>